const semverRegex = /^v?((\d+)\.(\d+)\.(\d+))(?:-([\dA-Za-z-]+(?:\.[\dA-Za-z-]+)*))?(?:\+([\dA-Za-z-]+(?:\.[\dA-Za-z-]+)*))?$/

export type Semver = {
  semver: string
  version: string
  major: string
  minor: string
  patch: string
}

export const parseSemver = (versionString: string): Semver | null => {
  const parts = semverRegex.exec(versionString)

  if (!parts) {
    return null
  }

  return {
    semver: parts[0],
    version: parts[1],
    major: parts[2],
    minor: parts[3],
    patch: parts[4],
  }
}

export enum SemverComparisonResult {
  HIGHER,
  LOWER,
  EQUAL,
}

export const compareSemvers = (
  a: Semver,
  b: Semver,
): SemverComparisonResult => {
  if (parseInt(a.major, 10) > parseInt(b.major, 10)) {
    return SemverComparisonResult.HIGHER
  }
  if (parseInt(b.major, 10) > parseInt(a.major, 10)) {
    return SemverComparisonResult.LOWER
  }

  if (parseInt(a.minor, 10) > parseInt(b.minor, 10)) {
    return SemverComparisonResult.HIGHER
  }
  if (parseInt(b.minor, 10) > parseInt(a.minor, 10)) {
    return SemverComparisonResult.LOWER
  }

  if (parseInt(a.patch, 10) > parseInt(b.patch, 10)) {
    return SemverComparisonResult.HIGHER
  }
  if (parseInt(b.patch, 10) > parseInt(a.patch, 10)) {
    return SemverComparisonResult.LOWER
  }

  return SemverComparisonResult.EQUAL
}
